import { render } from "./MemberNewsletterWidget.vue?vue&type=template&id=769c12c2&scoped=true"
import script from "./MemberNewsletterWidget.vue?vue&type=script&lang=js"
export * from "./MemberNewsletterWidget.vue?vue&type=script&lang=js"

import "./MemberNewsletterWidget.vue?vue&type=style&index=0&id=769c12c2&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769c12c2"]])

export default __exports__